import { render } from "./WagoEnergyStats.vue?vue&type=template&id=1a4ca845&scoped=true&ts=true"
import script from "./WagoEnergyStats.vue?vue&type=script&lang=ts"
export * from "./WagoEnergyStats.vue?vue&type=script&lang=ts"

import "./WagoEnergyStats.vue?vue&type=style&index=0&id=1a4ca845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4ca845"]])

export default __exports__